module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('bo-content', [_c('p', [_vm._v("巴旦木其实就是过去我们比较熟悉的大杏仁（美国加州大杏仁），只是因为其实它是扁桃仁，不是杏的仁，因此按照食品安全法，为了不让大家引起歧义，必须改为巴旦木或者扁桃仁。\n\n从营养角度来说，它大概含有一半脂肪，还有接近20%的蛋白质，这些和一般的坚果没有太多区别，主要的差异在于它的膳食纤维、钙含量比普通坚果多很多。\n\n")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4d8a9c17!./~/vue-loader/lib/selector.js?type=template&index=0!./src/other/content/demo.vue
// module id = 247
// module chunks = 25